import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import ArnicaConfigListing from "./ArnicaConfigListing";
import ArnicaCredentialsForm from "./ArnicaCredentialsForm";

export default function ArnicaPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={ArnicaCredentialsForm}
      PullConfigListingView={ArnicaConfigListing}
    />
  );
}